import { FC } from 'react';

import { AutoCompleteItemSkeleton, AutoCompleteSkeletonsWrapper } from './Skeletons.styles';

export const AutoCompleteSkeleton: FC = () => {
    return (
        <AutoCompleteSkeletonsWrapper>
            <AutoCompleteItemSkeleton />
            <AutoCompleteItemSkeleton />
            <AutoCompleteItemSkeleton />
            <AutoCompleteItemSkeleton />
            <AutoCompleteItemSkeleton />
        </AutoCompleteSkeletonsWrapper>
    );
};
